import * as React from "react"
import { Link, graphql, StaticQuery } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image"
import "/src/styles/SectionSpeakers.css"
import parse from "html-react-parser"

const SPEAKERS_QUERY = graphql`
query {
    headshotSpeakers: allMarkdownRemark(
      filter: { frontmatter: { type: { eq: "ftrspeaker" } } }
      sort: { fields: frontmatter___order, order: ASC }
      limit: 6
    ) {
      nodes {
        html
        frontmatter {
          title
          slug
          featuredImage {
            childImageSharp {
              gatsbyImageData(
                formats: WEBP
                placeholder: BLURRED
                transformOptions: { fit: COVER }
              )
            }
          }
        }
      }
    }
    wideShotSpeakers: allMarkdownRemark(
      filter: { frontmatter: { type: { eq: "widespeaker" } } } 
      sort: { fields: frontmatter___order, order: ASC }
      limit: 2
    ) {
      nodes {
        html
        frontmatter {
          title
          slug
          featuredImage {
            childImageSharp {
              gatsbyImageData(
                formats: WEBP
                placeholder: BLURRED
                transformOptions: { fit: COVER }
              )
            }
          }
        }
      }
    }
  }
`

const SectionSpeakers = props => {
  return (
    <>
      <div id="speakers" className="home-spkr-header">
        <h1 id="speakers-header">
          <strong>Featured Speakers & Emcee
          </strong>
        </h1>
        <hr />
      </div>
      <div className="feature-spkr-container">
        <StaticQuery
          query={SPEAKERS_QUERY}
          render={({ headshotSpeakers: { nodes: headshotPosts }, wideShotSpeakers: { nodes: wideShotPosts } }) => {
            return (
              <>
                {/* Headshot Grid */}
                <div className="feature-spkr-grid">
                  {headshotPosts.map(post => (
                    <div
                      key={post.frontmatter.slug}
                      className="feature-spkr-card"
                    >
                      <div className="feature-spkr-img-wrapper">
                        <GatsbyImage
                          image={
                            post.frontmatter.featuredImage.childImageSharp
                              .gatsbyImageData
                          }
                          alt={post.frontmatter.title}
                          className="feature-spkr-img"
                          loading="lazy"
                          imgStyle={{ objectFit: "cover" }}
                        />
                      </div>

                      <div className="feature-spkr-details">
                        <div className="feature-spkr-details-inner">
                          <h2 className="feature-spkr-name"><strong>{post.frontmatter.title}</strong></h2>
                          {parse(post.html)}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>

                {/* Wide Shot Grid - 1x2 */}
                {wideShotPosts.length > 0 && (
                  <div className="wide-spkr-grid">
                    {wideShotPosts.map(post => (
                      <div
                        key={post.frontmatter.slug}
                        className="wide-spkr-card"
                      >
                        <div className="wide-spkr-img-wrapper">
                          <GatsbyImage
                            image={
                              post.frontmatter.featuredImage.childImageSharp
                                .gatsbyImageData
                            }
                            alt={post.frontmatter.title}
                            className="wide-spkr-img"
                            loading="lazy"
                            imgStyle={{ objectFit: "cover" }}
                          />
                        </div>

                        <div className="wide-spkr-details">
                          <div className="wide-spkr-details-inner">
                            <h2 className="wide-spkr-name"><strong>{post.frontmatter.title}</strong></h2>
                            {parse(post.html)}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </>
            )
          }}
        />
      </div>
    </>
  )
}

export default SectionSpeakers